<!--
 * @Author: Merlin
 * @Date: 2024-06-10 11:00:49
 * @LastEditors: Merlin
 * @LastEditTime: 2024-11-21 10:30:15
 * @Description: 
-->

<template>
    <div class="multi-set">
        <div class="multi-bust">
            <div class="input input_lg input_animated"
                style="--1e92a94a: 31.810000000000002px;"
            >
                <InputBoxAmount
                    mode="multiple"
                    inputmode="numeric" 
                    suffix="x"
                    :disabled="!!0"
                    :tailLong="[0, 0]"
                    _min="joinStateStore?.betttingLimits?.minBetAmount"
                    _max="joinStateStore?.betttingLimits?.maxBets"
                    v-model="iRangeValue" 
                    :label="$t('waves.calc_PayoutMultiplier')"
                    :min="1"
                    :max="1_000"
                    :tip="oTip02"
                    @input="fnRangeValueOperator($event)" 
                />
            </div>
            <!-- ↓ 计算器窗口专用的爆仓金额 -->
            <div class="multi-bust__bust"
                v-if="showBust"
            >
                <div class="multi-bust__title">
                    {{ $t('waves.calc_BustPrice') }}
                </div>
                <div class="multi-bust__value">
                    {{bustPrice}}
                </div>
            </div>
        </div>
        <div class="range multi-set__range"
            modelmodifiers="[object Object]"
            style="--height: 7px; --knob-size: 16px; --rail-color: #55657e; --fill-color: #2283f6; --knob-color: #fff; --percent: 0%;" 
        >
            <!-- 范围 0-9 共10级 -->
            <input
                class="range__input" 
                type="range"
                step="1"
                min="0"
                max="9"
                v-model="iRangeLevel"
                @input="fnRangeLevelOperator($event)"
            />
        </div>
        <!-- 
            ↓ 最下方的信息栏 
        -->
        <div class="multi-set__range-info">
            <div class="multi-set__range-desc">
                x1 {{ $t('waves.calc_Safe') }}
            </div>
            <div class="multi-set__range-desc">
                {{ $t('waves.calc_Wild') }} x1000
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const {t: $t} = useI18n();
const props = defineProps({
    modelValue: [Number, String], 
    showBust: Boolean,
    bustPrice: Number,
});

const emit = defineEmits(['update:modelValue'])
const iRangeLevel = ref(0); // 0-9 共10级 
const [iMinMultiple, iMaxMultiple] = [1, 1_000]; // 倍数范围 
const iRangeValue = ref(Number(props.modelValue) || 1);
const aLevel2Number = [
    iMinMultiple,
    2, 5, 10, 20, 50,
    100, 200, 500,
    iMaxMultiple,
];

const oTip02 = ref({
    min: $t(`minMax.min_coefficient`),
    max: $t(`minMax.max_coefficient`),
});

// ↓ 应对用户滑动 
function fnRangeLevelOperator(ev){
    // console.log("ev", ev.target.value);
    const {value} = ev.target;
    const iFinalValue = aLevel2Number[value];
    iRangeValue.value = iFinalValue;
    emit('update:modelValue', Number(iFinalValue));
}

// ↓ 应对用户输入数值  
function fnRangeValueOperator(ev){
    // console.log("ev", ev.target.value);
    let {value} = ev.target;
    setBarPosition(value);
}

// ↓ 使用数值设定滑块位置 
const setBarPosition = (inputValue)=>{
    const iInput = Math.min(Number(inputValue), iMaxMultiple); 
    let idx = aLevel2Number.reduce((lastIndex, cur, index) => {
        if (index === 0) {
            return index; // 第1关，无条件放行  
        }
        const iPrevious = aLevel2Number[index - 1];
        const fHalfStep = (cur - iPrevious) / 2;
        const iMiddleValue = iPrevious + fHalfStep; 
        // console.log('数值：', iPrevious, iMiddleValue, cur); 
        if (iInput >= iMiddleValue) {
            return index;
        }
        return lastIndex;
    }, 0);
    iRangeLevel.value = idx;
    emit('update:modelValue', Number(iInput));
}

watch(
    ()=>props.modelValue,
    (iNewVal)=>{
        // console.log("滑杆组件收到的倍数值数值：", iNewVal); 
        iRangeValue.value = Number(iNewVal);
        setBarPosition(iNewVal);
    },
    {immediate: true},
);


</script>

<style scoped lang="scss">
// ===== ↓ 滑杆相关样式 1 ================================ 
.range__input {
    -moz-appearance: none!important;
    appearance: none!important;
    -webkit-appearance: none!important;
    background: linear-gradient(to right,var(--fill-color) 0, var(--fill-color) var(--percent),var(--rail-color) var(--percent),var(--rail-color) 100%);
    border: none;
    border-radius: 4px;
    cursor: pointer;
    height: var(--height);
    outline: none;
    width: 100%
}

.range__input::-webkit-slider-thumb {
    -webkit-appearance: none!important;
    background-color: var(--knob-color, red);
    background-image: url(../img/input-range-icon.webp);
    background-position: 50%;
    background-size: 150%;
    border: none;
    border-radius: 50%;
    box-shadow: 0 0 0 6px #2283f642;
    height: var(--knob-size);
    width: var(--knob-size)
}

.range__input--disabled {
    cursor: default;
    opacity: .5
}

// ===== ↓ 滑杆相关样式 2 ================================ 


.multi-set {
    grid-area: multi-set;
    width: 100%
}


.multi-set .range .range__input {
    background: linear-gradient(90deg,#1bb83dcc,#ffed4ecc 50%, #ed1d49cc);
}

.multi-set .multi-bust {
    align-items: center;
    display: flex;
    gap: 12px;
    min-width: 100%;
    // ↓ 补充
    & > .input_lg {
        width: 100%;
    }
}

.multi-set .multi-bust__bust {
    min-width: 33%
}

.multi-set .multi-bust__title {
    color: var(--color_grey-40);
    font-size: 12px;
    line-height: 16px
}

.multi-set .multi-bust__title,
.multi-set .multi-bust__value {
    font-weight: 600;
    letter-spacing: -.02em;
    margin-bottom: 0;
    margin-top: 0
}

.multi-set .multi-bust__value {
    color: var(--02---Text-Secondary,#a7b5ca);
    font-size: 14px;
    line-height: 18px
}

.multi-set .range-slider-knob {
    box-shadow: 0 0 0 4px #2283f642
}

.multi-set--disabled {
    opacity: .5
}


.multi-set__range {
    margin: 8px 0
}

.multi-set__range-info {
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%
}

.multi-set__range-desc {
    color: var(--color_grey-40);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 14px;
    margin-bottom: 0;
    margin-top: 0
}
</style>
